import { SuburbanUtilitiesContainer } from '../../containers/advancedFilters/SuburbanUtilitiesContainer';
import { IFilter } from '../../types/advancedFilters';

export const suburbanUtilities: IFilter = {
  component: SuburbanUtilitiesContainer,
};
